import { DataSource } from '~/Api/DataSource';
import Price from '~/utils/Price';

export default class ReferencedProduct {
	id: string;

	currentMaximumWholesalePrice: Price | null;

	dataSource: DataSource;

	constructor(id: string, currentMaximumWholesalePrice: Price | null, dataSource: DataSource) {
		this.id = id;
		this.currentMaximumWholesalePrice = currentMaximumWholesalePrice;
		this.dataSource = dataSource;
	}
}
